import i18n from "i18next";
import Cache from "i18next-localstorage-cache";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { buildexEN, tradexEN } from "./en/index";
import { TRANSLATIONS_ZH } from "./zh/";

i18n.use(LanguageDetector).use(Cache).use(initReactI18next).init({
	fallbackLng: "en",
	resources: {
		en: {
			translation: process.env.REACT_APP_DEX_ENV === 'sgbuildex' ? buildexEN : tradexEN,
		},
		zh: {
			translation: TRANSLATIONS_ZH
		}
	},
	interpolation: {
		format(value, format) {
			if(format === 'lowercase') return value.toLowerCase();
			return value
		},
		escapeValue: false
	},
	Cache: {
		enabled: true,
		prefix: 'translation_',
		expirationTime: Infinity,
	},
});

export default i18n;
// i18n.changeLanguage("en");
